import { useEffect, useRef } from 'react';

const useScrollLock = (shouldLock: boolean) => {
    const originalBodyOverflowRef = useRef<string | null>(null);
    const originalHtmlOverflowRef = useRef<string | null>(null);
    const originalMarginRef = useRef<string | null>(null);

    const getScrollbarWidth = () => {
        return window.innerWidth - document.documentElement.clientWidth;
    };

    useEffect(() => {
        const { body, documentElement } = document;

        if (shouldLock) {
            if (originalBodyOverflowRef.current === null) {
                originalBodyOverflowRef.current = body.style.overflow;
                originalHtmlOverflowRef.current = documentElement.style.overflow;
                originalMarginRef.current = documentElement.style.marginRight;
            }

            const scrollbarWidth = getScrollbarWidth();

            body.style.overflow = 'hidden';
            documentElement.style.overflow = 'hidden';
            documentElement.style.marginRight = `${scrollbarWidth}px`;
        } else {
            if (originalBodyOverflowRef.current !== null) {
                body.style.overflow = originalBodyOverflowRef.current;
                documentElement.style.overflow = originalHtmlOverflowRef.current ?? '';
                documentElement.style.marginRight = originalMarginRef.current ?? '';
                originalBodyOverflowRef.current = null;
                originalHtmlOverflowRef.current = null;
                originalMarginRef.current = null;
            }
        }

        return () => {
            if (originalBodyOverflowRef.current !== null) {
                body.style.overflow = originalBodyOverflowRef.current;
                documentElement.style.overflow = originalHtmlOverflowRef.current ?? '';
                documentElement.style.marginRight = originalMarginRef.current ?? '';
                originalBodyOverflowRef.current = null;
                originalHtmlOverflowRef.current = null;
                originalMarginRef.current = null;
            }
        };
    }, [shouldLock]);
};

export default useScrollLock;